export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('form_label_userReimbursementNo') || '日常请款单编号',
    field: 'userReimbursementNo',
    minWidth: 150,
    align: 'center',
  },
  {
    title: that.$l('table_label_salesPersonCode') || '业务人员',
    field: 'salesPersonName',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('form_label_requestDate') || '申请日期',
    field: 'requestDate',
    minWidth: 100,
    align: 'center',
  },
  {
    title: that.$l('form_label_userReimbursementStatus') || '状态',
    field: 'userReimbursementStatus',
    minWidth: 100,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_expensePayerName') || '申请人公司',
    field: 'expensePayerName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
  },
  {
    title: that.$l('form_label_currencyAmount') || '费用合计',
    field: 'v_currencyAmount',
    minWidth: 150,
    align: 'center',
    slots: { default: 'showAmount' },
  },
  {
    title: that.$l('form_label_cashAdvances') || '预支金额',
    field: 'v_cashAdvances',
    minWidth: 150,
    align: 'center',
    slots: { default: 'cashAdvances' },
  },
  {
    title: that.$l('table_label_costCategory') || '费用大类',
    field: 'v_costCategory',
    minWidth: 150,
    align: 'center',
  },
  {
    title: that.$l('form_label_paymentMethod') || '付款方式',
    field: 'v_paymentMethod',
    minWidth: 150,
    align: 'center',
  },
  {
    title: that.$l('table_label_substituteInvoice') || '代用发票',
    field: 'substituteInvoice',
    minWidth: 80,
    align: 'center',
    slots: { default: 'substituteInvoice' },
  },
  {
    title: that.$l('table_label_forwardGeneralManager') || '转送总经理',
    field: 'forwardGeneralManager',
    minWidth: 100,
    align: 'center',
    slots: { default: 'forwardGeneralManager' },
  },
  {
    title: that.$l('table_label_businessConsumption') || '业务消费',
    field: 'businessConsumption',
    minWidth: 80,
    align: 'center',
    slots: { default: 'businessConsumption' },
  },
  {
    title: that.$l('table_label_otherSet') || '420',
    field: 'otherSet',
    minWidth: 80,
    align: 'center',
    slots: { default: 'otherSet' },
  },
  {
    title: that.$l('table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    slots: { default: 'createByName' },
  },
  {
    title: that.$l('table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    slots: { default: 'modifyByName' },
  },
]
